import moment from 'moment';

export const toDateValue = (
  value: Date | string | null | undefined,
): Date | undefined => (value ? moment(value).toDate() : undefined);

export const isDateToday = (date: Date | string | null | undefined): boolean =>
  date ? moment().isSame(date, 'day') : false;

export const isTimeInPast = (timeId: string): boolean => {
  const [hours, minutes] = timeId.split(':').map(Number);
  const selected = moment().hour(hours).minute(minutes).second(0).millisecond(0);
  return selected.isBefore(moment());
};

export const mergeDateTime = (date: Date, timeId: string): Date => {
  const [hours, minutes] = timeId.split(':').map(Number);
  return moment(date)
    .hour(hours)
    .minute(minutes)
    .second(0)
    .millisecond(0)
    .utc()
    .toDate();
};
